module.exports = __webpack_public_path__ + "assets/img/aqx2.c8b9e330.jpg";